import {Flex, SimpleGrid, Text} from '@chakra-ui/react'

const ItemInfoBoard = ({message}: {message: any}) => {
  const getBackgroundColor = (type: string) => {
    switch (type) {
      case 'background':
        return '#FFFE00'
      case 'event':
        return '#6D9EEB'
      case 'result':
        return '#B6D8A8'
      case 'emotion':
        return '#D5A7BD'
      default:
        return '#ffffff'
    }
  }

  function renderMultiLineString(str: string) {
    const lines = str.split('\n')
    return lines.map((string, index) => <Text key={index}>{string}</Text>)
  }

  return (
    <SimpleGrid
      columns={{base: 1, md: 2, lg: 4}}
      spacing={'16px'}
      className="item-info-board">
      {message?.message?.length > 0 &&
        message?.message?.map((item: any, index: number) => {
          return (
            <Flex
              key={index}
              flexDirection={'column'}
              justifyContent={'center'}
              alignItems={'center'}
              p={'16px'}
              border={'1px'}
              borderColor={'#ccc'}
              borderRadius={'16px'}
              flexGrow={1}
              backgroundColor={getBackgroundColor(item.type)}>
              <Text fontWeight={700}>{item.title}</Text>
              {renderMultiLineString(item.content)}
            </Flex>
          )
        })}
    </SimpleGrid>
  )
}

export default ItemInfoBoard
